'use client';

import { HeaderConsumer, HeaderContextController, HeaderScroller } from './components';

type HeaderController = typeof HeaderContextController & {
  Consumer: typeof HeaderConsumer;
  Scroller: typeof HeaderScroller;
};

export const HeaderProvider = Object.assign( HeaderContextController, {
  Consumer: HeaderConsumer,
  Scroller: HeaderScroller,
} ) as HeaderController;
